var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-control"},[_c('select',{ref:"select",attrs:{"name":_vm.name},on:{"change":_vm.onSelectChanged}},_vm._l((_vm.options),function(item,index){return _c('option',{key:index,domProps:{"value":JSON.stringify(item.value)}},[_vm._v(_vm._s(item.label)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }